<template>
  <div>
    <div class="custom-title-container">
      <img class="custom-title-bg" src="@/assets/Vocabulary/VocabularyPageTitleBackground.jpg" />
      <img class="custom-thumbnail" src="@/assets/Vocabulary/VocabularyPageThumbnail.png" />
      <label class="custom-title-text">{{ $t('AppLayout.vocabularyTitle') }}</label>
    </div>
    <div class="body-container">
      <b-overlay :show="wait" rounded="sm">
        <div class="form-container-1">
          <div class="form-container-2">
            <PracticeSettingForm :nextStep="nextStep"></PracticeSettingForm>
          </div>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PracticeSettingForm from '../../components/Vocabulary/PracticeSettingForm/PracticeSettingForm'

export default {
  name: 'Vocabulary',
  components: {
    PracticeSettingForm
  },
  computed: {
    ...mapState({
      wait: state => state.glossary.waitForFetching
    })
  },
  methods: {
    nextStep () {
      this.$router.push('/wordPractice')
    }
  }
}
</script>

<style lang='scss' scoped>
@import "./styles/vocabularyStyles.scss";
</style>
